export const TEXT_CONFIGURATION_TYPE = 'text' as const;
export const USERNAME_CONFIGURATION_TYPE = 'username' as const;
export const PASSWORD_CONFIGURATION_TYPE = 'password' as const;
export const PASSWORD_MULTILINE_CONFIGURATION_TYPE = 'multiline_password' as const;
export const BOOLEAN_CONFIGURATION_TYPE = 'boolean' as const;
export const INTEGER_CONFIGURATION_TYPE = 'integer' as const;
export const ARRAY_CONFIGURATION_TYPE = 'array' as const;
export const PRIMITIVE_FIELDS_CONFIGURATION_TYPES = [
  TEXT_CONFIGURATION_TYPE,
  USERNAME_CONFIGURATION_TYPE,
  PASSWORD_CONFIGURATION_TYPE,
  PASSWORD_MULTILINE_CONFIGURATION_TYPE,
  BOOLEAN_CONFIGURATION_TYPE,
  INTEGER_CONFIGURATION_TYPE,
] as const;
export const CONFIGURATION_TYPES = [...PRIMITIVE_FIELDS_CONFIGURATION_TYPES, ARRAY_CONFIGURATION_TYPE] as const;

export const AVAILABILITY_TYPES = ['available', 'internal', 'preview', 'legacy'] as const;
